async function autoAddToCart() {
  const autoAddSkipParam = "skip_auto_add";

  // If the session cookie exists, never auto-add products.
  const hasSkipAutoAddCookie = document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .some((cookie) => cookie.startsWith(`${autoAddSkipParam}=`));
  if (hasSkipAutoAddCookie) return;

  const blocks = window.autoAddToCartBlocks || [];
  if (blocks.length === 0) return;

  const cartResponse = await fetch("/cart.js");
  const cartData = await cartResponse.json();
  const currentPath = window.location.pathname;
  const currentAbsolutePath = window.location.origin + currentPath;
  const isCustomer = window.isCustomer;

  for (const block of blocks) {
    const products = block.products || [];
    const triggerUrl = block?.trigger_url;
    const isCustomerOnly = block?.is_customer_only;
    const isUrlMatch =
      triggerUrl === currentAbsolutePath || triggerUrl === currentPath;

    // Only run for blocks whose trigger URL matches this page and customer rules.
    if (!isUrlMatch || (isCustomerOnly && !isCustomer)) continue;

    const itemsToAdd = [];

    for (const product of products) {
      const targetQuantity = Number(product.quantity);
      const variantId = Number(product.variant_id);
      const existingQuantity = cartData.items
        .filter((item) => item.id === variantId)
        .reduce((sum, item) => sum + Number(item.quantity), 0);

      // Add only the missing quantity so the cart ends up at the configured amount.
      if (existingQuantity < targetQuantity) {
        itemsToAdd.push({
          id: product.variant_id,
          quantity: targetQuantity - existingQuantity,
        });
      }
    }

    // Add all required variants in one request when the cart controller is available.
    if (itemsToAdd.length > 0) {
      if (
        window.CartController &&
        typeof window.CartController.addItems === "function"
      ) {
        window.CartController.addItems(itemsToAdd, false);
      } else {
        console.error("CartController.addItems is not available.");
      }
    }

    // Stop after the first matching block to preserve existing behavior.
    break;
  }
}

window.addEventListener("load", autoAddToCart);
